import { useParams } from "react-router-dom";
import { UserDetailProvider } from "../core/QueryResponseProvider";
import EditUser from "./EditUser";
import { QueryRequestProvider } from "../../merchant-management/core/QueryRequestProvider";
import { QueryResponseProvider } from "../../merchant-management/core/QueryResponseProvider";

const EditUserWrapper = () => {
  const { id } = useParams();
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <UserDetailProvider id={id ?? ""}>
          <EditUser />
        </UserDetailProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  );
};

export default EditUserWrapper;
